module.exports = __webpack_public_path__ + "f7b688df3fe54322e6a2cd7a50e68d0c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-granny.png
// module id = 2837
// module chunks = 0